import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=bc2c754e&scoped=true&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/login.css?vue&type=style&index=0&id=bc2c754e&prod&scoped=true&lang=css&"
import style1 from "../assets/css/util.css?vue&type=style&index=1&id=bc2c754e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2c754e",
  null
  
)

export default component.exports